export default "__VITE_ASSET__DBU6wVom__"